export type DashboardTone = 'red' | 'amber' | 'blue' | 'emerald' | 'brand' | 'zinc';
export type DashboardToneStyle = 'accent' | 'muted';

const TONE_CLASSES: Record<DashboardToneStyle, Record<DashboardTone, string>> = {
  accent: {
    red: 'border-red-500/30 bg-red-500/10 text-red-300',
    amber: 'border-amber-500/30 bg-amber-500/10 text-amber-300',
    blue: 'border-blue-500/30 bg-blue-500/10 text-blue-300',
    emerald: 'border-brand-500/30 bg-brand-500/10 text-brand-300',
    brand: 'border-brand-500/30 bg-brand-500/10 text-brand-300',
    zinc: 'border-zinc-700 bg-zinc-900 text-zinc-400',
  },
  muted: {
    red: 'border-red-800 bg-red-950/20 text-red-300',
    amber: 'border-amber-800 bg-amber-950/20 text-amber-300',
    blue: 'border-blue-800 bg-blue-950/20 text-blue-300',
    emerald: 'border-brand-800 bg-brand-950/20 text-brand-300',
    brand: 'border-brand-800 bg-brand-950/20 text-brand-300',
    zinc: 'border-zinc-700 bg-zinc-900 text-zinc-400',
  },
};

export function dashboardToneClasses(tone: DashboardTone, style: DashboardToneStyle = 'accent'): string {
  return TONE_CLASSES[style][tone];
}
